import * as Api from '@ViewModels';
import { Provider, inject } from 'mobx-react';
import * as React from 'react';
import { useLocation } from 'react-router';
import {
	IImpersonationContextComponentProps,
	ILocationState,
	IModalContext,
	ModalChildComponentContextKey,
} from '../../../../models';
import { ImpersonationContextViewModel } from '../../../../viewmodels/AdminViewModels';
import { EditSocialMediaPost } from '../../../../web/containers/socialMedia/EditSocialMediaPost';

const AdminEditSocialMediaPostBase: React.FC<IModalContext> = ({ parentModal }) => {
	const loc = useLocation<ILocationState<Api.SocialMediaPostReportViewModel, any>>();
	const impersonationProviderProps = React.useRef<IImpersonationContextComponentProps>({
		impersonationContext: new ImpersonationContextViewModel(
			loc.state?.viewModel?.impersonationContext ?? loc.state?.model?.impersonationContext
		),
	}).current;
	const onPostUpdated = () => {
		parentModal?.onRequestClose?.();
		return true;
	};

	return (
		<Provider {...impersonationProviderProps}>
			<EditSocialMediaPost onPostUpdated={onPostUpdated} />
		</Provider>
	);
};

export const AdminEditSocialMediaPost = inject(ModalChildComponentContextKey)(AdminEditSocialMediaPostBase);
